/*
 * Luxgear pre-checkout gate. It fails closed when cart data or the approved
 * variant asset is unavailable, so an unvalidated item never reaches checkout.
 */
(function () {
  'use strict';

  var ADDRESS_CHECK_PATH = '/pages/address-check';
  var PRODUCT_PATH_PREFIX = '/products/';
  var statusId = 'luxgear-address-gate-status';
  var redirecting = false;

  if (window.location.pathname === ADDRESS_CHECK_PATH || window.location.pathname.indexOf('/checkout') === 0) {
    return;
  }

  function approvedVariants() {
    var ids = window.__LUXGEAR_ALLOWED_VARIANT_IDS__;
    if (!Array.isArray(ids)) return null;
    return new Set(ids.map(String));
  }

  function trackInitiateCheckout(items) {
    var totalQuantity = (items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    var contentIds = (items || []).map(function (item) {
      return String(item.variant_id || item.id || '');
    }).filter(Boolean);
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_ids: contentIds,
        content_type: 'product',
        num_items: totalQuantity
      });
      return;
    }
    var params = new URLSearchParams({
      id: '2104510900331758',
      ev: 'InitiateCheckout',
      dl: window.location.href,
      rl: document.referrer,
      if: 'false',
      ts: String(Date.now()),
      v: '2.9.349',
      noscript: '1',
      cd: JSON.stringify({ content_ids: contentIds, content_type: 'product', num_items: totalQuantity })
    });
    try {
      navigator.sendBeacon('https://www.facebook.com/tr/?' + params.toString());
    } catch (error) {
      (new Image()).src = 'https://www.facebook.com/tr/?' + params.toString();
    }
  }

  function statusElement() {
    var element = document.getElementById(statusId);
    if (element) return element;

    element = document.createElement('div');
    element.id = statusId;
    element.className = 'luxgear-address-gate__status';
    element.setAttribute('role', 'alert');
    element.setAttribute('tabindex', '-1');
    document.body.insertAdjacentElement('afterbegin', element);
    return element;
  }

  function showError(message) {
    var element = statusElement();
    element.textContent = message;
    element.hidden = false;
    element.focus({ preventScroll: false });
  }

  function appendStyles() {
    if (document.getElementById('luxgear-address-gate-styles')) return;
    var style = document.createElement('style');
    style.id = 'luxgear-address-gate-styles';
    style.textContent = [
      '.luxgear-address-gate__status{position:fixed;z-index:1000;top:1.6rem;left:50%;width:min(48rem,calc(100% - 3.2rem));transform:translateX(-50%);padding:1.2rem 1.6rem;border:.1rem solid rgb(var(--color-foreground));border-radius:var(--inputs-radius);background:rgb(var(--color-background));color:rgb(var(--color-foreground));box-shadow:0 .4rem 1.4rem rgba(var(--color-shadow),.2);font:inherit}',
      '.luxgear-address-gate__buy-now{min-height:4.4rem;margin-top:1.2rem}',
      '.luxgear-address-gate__buy-now:focus-visible{outline:.2rem solid currentColor;outline-offset:.3rem}'
    ].join('');
    document.head.appendChild(style);
  }

  function validLineItem(variantId, quantity, allowed) {
    return /^\d+$/.test(String(variantId)) && Number.isSafeInteger(quantity) && quantity > 0 && allowed.has(String(variantId));
  }

  function checkoutCartState(cart) {
    var allowed = approvedVariants();
    if (!allowed) {
      showError('Checkout is temporarily unavailable because product eligibility could not be verified. Please refresh and try again.');
      return null;
    }
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      showError('Your cart is empty. Add an approved product before checking out.');
      return null;
    }

    var lines = [];
    for (var index = 0; index < cart.items.length; index += 1) {
      var item = cart.items[index] || {};
      var variantId = String(item.variant_id || item.id || '');
      var quantity = Number(item.quantity);
      if (!validLineItem(variantId, quantity, allowed)) {
        showError('This cart contains a product that is not available for checkout. Remove it from your cart and try again.');
        return null;
      }
      lines.push(variantId + ':' + quantity);
    }
    return {
      variants: lines.join(','),
      cartToken: typeof cart.token === 'string' ? cart.token : '',
      items: cart.items
    };
  }

  function redirectToAddressCheck(state) {
    if (!state || !state.variants || redirecting) return;
    redirecting = true;
    var params = new URLSearchParams({ variants: state.variants });
    if (state.cartToken) params.set('cart_token', state.cartToken);
    if (state.productPath && /^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(state.productPath)) {
      params.set('product_path', state.productPath.replace(/\/$/, ''));
    } else if (state.productHandle) {
      params.set('product_path', '/products/' + state.productHandle);
    }
    trackInitiateCheckout(state.items);
    window.location.assign(ADDRESS_CHECK_PATH + '?' + params.toString());
  }

  function fetchCartAndRedirect() {
    if (redirecting) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var state = checkoutCartState(cart);
        if (state) redirectToAddressCheck(state);
      })
      .catch(function () {
        showError('We could not verify your cart. Please refresh the page and try checkout again.');
      });
  }

  function findQuickAddForm(el) {
    if (!el || !(el instanceof Element)) return null;
    // Dawn nests the quick-add form inside <quick-add-modal> → divs → <product-form> → <form>.
    // querySelector from the modal won't pierce the product-form custom element's
    // shadow boundary, but .closest() from the clicked button walks up the composed
    // tree and reliably finds the enclosing form.
    return el.closest('form[action*="/cart/add"]');
  }
  function selectedProductLine(formEl) {
    var form = formEl instanceof HTMLFormElement ? formEl : (findQuickAddForm(formEl) || document.querySelector('form[action*="/cart/add"]'));
    if (!form) return null;
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return null;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    // Resolve the product handle so the address-check page can fetch /products/{handle}.js
    // to render the visual summary. Prefer the form's data-product-handle, then the
    // enclosing product-info's data-product-handle, then the href of a product link.
    var handle = '';
    if (form.dataset && form.dataset.productHandle) {
      handle = form.dataset.productHandle;
    } else {
      var info = form.closest('[data-product-handle]');
      if (info && info.dataset.productHandle) handle = info.dataset.productHandle;
    }
    if (!handle) {
      // Quick-add modal in Dawn encodes the handle in the modal id (QuickAdd-<productId>),
      // but we can also infer it from the collection card's product link.
      var modal = form.closest('quick-add-modal');
      if (modal) {
        var id = modal.id || '';
        var pid = id.replace(/^QuickAdd-/, '');
        if (pid) {
          var link = document.querySelector('a[href*="/products/"][data-product-id="' + pid + '"]');
          if (!link) {
            // Fall back to any card whose data-product-id matches.
            link = document.querySelector('[data-product-id="' + pid + '"] a[href*="/products/"]');
          }
          if (link) {
            var m = /\/products\/([a-z0-9][a-z0-9-]+)/i.exec(link.getAttribute('href') || '');
            if (m) handle = m[1];
          }
        }
      }
    }
    return { variant_id: variantInput.value, quantity: quantity, handle: handle };
  }
  function redirectSelectedProduct(context) {
    var allowed = approvedVariants();
    if (!allowed) {
      showError('Checkout is unavailable right now. Please refresh the page and try again.');
      return;
    }

    // Dawn's variant-selects custom element populates the hidden [name="id"]
    // input asynchronously. If the customer clicks Buy it now before the
    // variant resolves, the value is empty. Wait briefly for it to populate.
    var attempts = 0;
    var maxAttempts = 15; // 15 × 100ms = 1.5s
    function attemptRedirect() {
      var product = selectedProductLine(context);
      if (product && product.variant_id && validLineItem(product.variant_id, Number(product.quantity), allowed)) {
        redirectToAddressCheck({ variants: String(product.variant_id) + ':' + Number(product.quantity), cartToken: '', productHandle: product.handle || '', items: [product] });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        window.setTimeout(attemptRedirect, 100);
        return;
      }
      showError('Select a product variant, then click Buy it now again.');
    }
    attemptRedirect();
  }

  function closestCheckoutControl(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .shopify-payment-button__button');
  }

  function controlIsDynamicBuyNow(control) {
    return control && control.classList.contains('shopify-payment-button__button');
  }

  function installDynamicBuyNowReplacement() {
    var onPdp = window.location.pathname.indexOf(PRODUCT_PATH_PREFIX) === 0;
    var containers = document.querySelectorAll('.shopify-payment-button, .dynamic-checkout-buttons');
    if (!containers.length) return false;

    var installedAny = false;
    containers.forEach(function (container) {
      if (container.dataset.luxgearAddressGate === 'installed') return;
      // On collection pages, only install inside a quick-add modal so we don't
      // touch theme chrome that isn't a Buy It Now surface.
      if (!onPdp && !container.closest('quick-add-modal, [role="dialog"], .modal, dialog')) return;
      container.dataset.luxgearAddressGate = 'installed';
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--full-width button--secondary luxgear-address-gate__buy-now';
      button.textContent = 'Buy it now';
      button.addEventListener('click', function () {
        var form = findQuickAddForm(button);
        redirectSelectedProduct(form);
      });
      container.insertAdjacentElement('afterend', button);
      installedAny = true;
    });
    return installedAny;
  }
  function interceptCheckoutClick(event) {
    var control = closestCheckoutControl(event.target);
    if (!control) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (controlIsDynamicBuyNow(control)) {
      // The dynamic Buy It Now button may live on a PDP or inside a quick-add
      // modal on a collection page. Scope lookups to the enclosing form so we
      // read the correct variant input regardless of where the button lives.
      var form = findQuickAddForm(event.target);
      redirectSelectedProduct(form);
      return;
    }
    fetchCartAndRedirect();
  }

  function interceptCheckoutSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/checkout') === -1) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    fetchCartAndRedirect();
  }

  appendStyles();
  document.addEventListener('click', interceptCheckoutClick, true);
  document.addEventListener('submit', interceptCheckoutSubmit, true);

  // Install on PDPs at load. On collection pages, Dawn injects the
  // .shopify-payment-button inside the quick-add modal when "Choose options"
  // opens it — keep watching so we install the replacement every time a modal
  // opens. Disconnecting after the first install breaks subsequent modal opens.
  installDynamicBuyNowReplacement();
  var pdpObserver = new MutationObserver(function () {
    installDynamicBuyNowReplacement();
  });
  pdpObserver.observe(document.body, { childList: true, subtree: true });
}());
